"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _menu = require("../utilities/menu");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var _desktop = _interopRequireDefault(require("../breakpoints/desktop"));
var _menuItem = _interopRequireDefault(require("./menuItem"));
var _navigationBar = _interopRequireDefault(require("../navigationBar"));
var _navigationLinks = _interopRequireDefault(require("../navigationLinks"));
var _skipMenuButton = _interopRequireDefault(require("../components/skipMenuButton"));
var _excluded = ["left", "right", "brandContainer"];
var useClasses = (0, _styles.makeStyles)({
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto'
  },
  brandContainer: {
    flexShrink: 0
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}, {
  classNamePrefix: 'TCUISiteMenuDesktop'
});
var SiteNavigation = function SiteNavigation(_ref) {
  var items = _ref.items,
    renderBrand = _ref.renderBrand,
    getItemKey = _ref.getItemKey,
    children = _ref.children,
    classes = _ref.classes,
    ButtonComponent = _ref.ButtonComponent,
    SkipMenuButtonProps = _ref.SkipMenuButtonProps,
    enableSkipMenuButton = _ref.enableSkipMenuButton,
    overflow = _ref.overflow,
    flexEnd = _ref.flexEnd;
  var _classes = useClasses();
  var left = classes.left,
    right = classes.right,
    brandContainer = classes.brandContainer,
    restClasses = (0, _objectWithoutProperties2.default)(classes, _excluded);
  var theme = (0, _styles.useTheme)();
  var isMobile = (0, _core.useMediaQuery)(theme.breakpoints.down('sm'));
  var appBarPosition = isMobile ? 'static' : 'sticky';
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: appBarPosition,
    color: "default",
    classes: restClasses
  }, /*#__PURE__*/_react.default.createElement(_navigationBar.default, {
    className: _classes.root,
    color: "primary",
    variant: "dense"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_classes.left, left)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_classes.brandContainer, brandContainer)
  }, renderBrand()), /*#__PURE__*/_react.default.createElement(_breakpoints.default, {
    direction: "down",
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_skipMenuButton.default, SkipMenuButtonProps)), /*#__PURE__*/_react.default.createElement(_desktop.default, null, enableSkipMenuButton && /*#__PURE__*/_react.default.createElement(_skipMenuButton.default, SkipMenuButtonProps))), /*#__PURE__*/_react.default.createElement(_desktop.default, null, /*#__PURE__*/_react.default.createElement(_navigationLinks.default, {
    collapsible: true,
    getItemKey: getItemKey,
    items: items,
    ButtonComponent: ButtonComponent,
    overflow: overflow,
    flexEnd: flexEnd
  })), children && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_classes.right, right)
  }, children)));
};
SiteNavigation.propTypes = {
  items: _propTypes.default.array,
  ButtonComponent: _propTypes.default.object,
  classes: _propTypes.default.object,
  BrandLinkProps: _propTypes.default.object,
  MenuItemProps: _propTypes.default.object,
  ToolbarProps: _propTypes.default.object,
  SkipMenuButtonProps: _propTypes.default.object,
  NavProps: _propTypes.default.object,
  renderBrand: _propTypes.default.func.isRequired,
  getKey: _propTypes.default.func,
  children: _propTypes.default.node,
  getItemKey: _propTypes.default.func,
  enableSkipMenuButton: _propTypes.default.bool
};
SiteNavigation.defaultProps = {
  getItemKey: _menu.getItemKey,
  items: [],
  ButtonComponent: _menuItem.default,
  BrandLinkProps: {},
  MenuItemProps: {},
  ToolbarProps: {},
  SkipMenuButtonProps: {},
  NavProps: {},
  children: null,
  classes: {},
  enableSkipMenuButton: false
};
var _default = SiteNavigation;
exports.default = _default;